import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Icon, Tabs, Row, Button, Modal, Col,Typography} from "antd";
import Formulario from "./FormBusquedaBandeja";
import ComponentTablaBandeja from "./TablaBandeja.js";
import ComponentTablaBandejaBusqueda from "./TablaBandejaBusqueda.js";
import AuthenticatedComponent from "./../../AuthenticatedComponent";
import Template from "./../../interfaz/Template.js";
import {
  etiqueta_bandeja_titulo_modulo, etiqueta_bandeja_registrados, etiqueta_bandeja_por_validar, etiqueta_bandeja_con_observaciones, etiqueta_bandeja_acuden_JDE, etiqueta_bandeja_declinados, etiqueta_bandeja_finalizados,
        etiqueta_resultado_registrados, etiqueta_resultado_validar, etiqueta_resultado_con_observaciones, etiqueta_resultado_acuden_JDE, etiqueta_resultado_declinados, etiqueta_resultado_finalizados,
        KEY_BANDEJA_REGISTRADOS, KEY_BANDEJA_POR_VALIDAR, KEY_BANDEJA_CON_OBSERVACIONES, KEY_BANDEJA_ACUDEN_JDE, KEY_BANDEJA_DECLINADOS, KEY_BANDEJA_FINALIZADOS
} from '../../../ApplicationResources';
import {  useSelector } from "react-redux";
import { Link } from "react-router-dom";
import '../../../css/modelStyle.css';
import IconoAtras from '../../../img/icons/arrow-left-circle-fill.svg';
import HeaderModule from "../../interfaz/Elements/HeaderModule";
import Menu from "../../interfaz/Elements/Menu";
import iconoDeclina from '../../../img/icons/Icono_declinacion.png';

const { Text } = Typography;
const { TabPane } = Tabs;

function Bandeja({ history }) {

  // Utilizar useState con 3 states
  const [bandejaSeleccionada, actualizaBandeja] = useState(0);
  const [tabla, agregartabla] = useState({});
  const [bandera, cambiarBandera] = useState({ bandera: true });
  const [cargando, cambiarCargando] = useState({ cargando: true });
  const [datosSesion, sesionData] = useState(false);
  const [tipoUsuario, establecerTipoUsuario] = useState(0);
  const [rolCaptura, establecerRolCaptura] = useState(false);
  const [avisoUsuarioNovalidoVisible, cambiarAvisoUsuarioNovalidoVisible] = useState({ avisoUsuarioNovalidoVisible : false });
  const datosAspirante = useSelector(state => state);
  const menu = useSelector(state => state.menu);
  const user = useSelector(state => state.user);

  const roles =
  [ "SCE.ADMIN.OC",
  "SCE.CAU.OC",
  "SCE.CAPTURA.OC",
  "SCE.CAPTURA.JL",
  "SCE.CAPTURA.JD",
  "SCE.CAPTURA_VCEYEC.JD",
  "SCE.CAPTURA_VCEYEC.JL",
  "SCE.CAPTURA_VE.JL",
  "SCE.CAPTURA_VE.JD",
  "SCE.CAPTURA_CONSEJERO.JL",
  "SCE.CAPTURA_CONSEJERO.JD"  ,"SCE.CONSULTA_EXT.REST.OC", "SCE.CONSULTA_EXT.REST.JL", "SCE.CONSULTA_EXT.REST.JD","SCE.CONSULTA_EXT.OPL.JL", "SCE.CONSULTA.OC", "SCE.CONSULTA.JL", "SCE.CONSULTA.JD"
];

const roles_solo_consulta =
  [ "SCE.CONSULTA_EXT.OPL.JL", "SCE.CONSULTA.OC", "SCE.CONSULTA.JL", "SCE.CONSULTA.JD"
];

  const funcionListo = () => {
    if(!roles.includes(datosAspirante.user.currentUser.rolUsuario)){
        cambiarAvisoUsuarioNovalidoVisible({ avisoUsuarioNovalidoVisible: true}); // No se permite la entrada del usuario
    }
    sesionData(true);
    consultar();
  };

  const buscarAspirante = async busqueda => {
    try {
      cambiarCargando({cargando : true});

      const { claveElector } = busqueda;

      const estado = menu.estados ? menu.estados[menu.idEstado] : undefined;
      const proceso = estado && estado.procesos ? estado.procesos[menu.idDetalle] : undefined;
      const distrito = proceso && proceso.distritos ? proceso.distritos[menu.idDistrito] : undefined;
  
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
      var idEstado = estado ? estado.idEstado : 0;
      var idDistrito = distrito ? distrito.idDistrito : 0;
  
      if(user.currentUser.idEstado === 0){
        establecerTipoUsuario(1); //OC
      }else{
        if(user.currentUser.idDistrito === 0){
          establecerTipoUsuario(2); //JL
        }else{
          establecerTipoUsuario(3); //JD
        }
      }
      var postData = {
        idProcesoElectoral: idProcesoElectoral,
        idDetalleProceso: idDetalleProceso,
        idEstado: idEstado,
        idDistrito: idDistrito,
        claveElector: claveElector
      };
      const jwt = localStorage.getItem("jwt-token");
      const resultado = await axios.post(
        process.env.REACT_APP_API_URL +
          "/ws_reclutaseycae_central/ws/buscarAspirante",
        postData,
        { headers: { Authorization: jwt } }
      );
      agregartabla({});
      agregartabla(resultado.data.tablaBandeja);
      cambiarBandera({ bandera: false });
      actualizaBandeja("6");
    } catch(err) {
      console.log("Error al carga la información del usuario", err)
    } finally {
      cambiarCargando({cargando : false});
    } 
  }

  function actualizaTab(key) {
    actualizaBandeja(key);
  }

  const consultar = async () => {
    const { rolUsuario } = datosAspirante.user.currentUser;

    const estado = menu.estados ? menu.estados[menu.idEstado] : undefined;
    const proceso = estado && estado.procesos ? estado.procesos[menu.idDetalle] : undefined;
    const distrito = proceso && proceso.distritos ? proceso.distritos[menu.idDistrito] : undefined;
    
    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
    const idEstado = estado ? estado.idEstado : 0;
    const idDistrito = distrito ? distrito.idDistrito : 0;
    
    if(user.currentUser.idEstado === 0){
      establecerTipoUsuario(1); //OC
    }else{
      if(user.currentUser.idDistrito === 0){
        establecerTipoUsuario(2); //JL
      }else{
        establecerTipoUsuario(3); //JD
      }
    }
    if (localStorage.estadoBandeja === undefined) {
      const estadoBandeja = {
        bandejaSeleccionada: bandejaSeleccionada,
        tabla: tabla
      };
      localStorage.setItem("estadoBandeja", estadoBandeja);
    }

    var postData = {
      bandejaSeleccionada: bandejaSeleccionada,
      idProcesoElectoral: idProcesoElectoral,
      idDetalleProceso: idDetalleProceso,
      idEstado: idEstado,
      idDistrito: idDistrito
    };
    const jwt = localStorage.getItem("jwt-token");
    if (bandejaSeleccionada < 6) {
      cambiarCargando({cargando : true});
      const resultado = await axios.post(
        process.env.REACT_APP_API_URL +
          "/ws_reclutaseycae_central/ws/obtenInformacionBandeja",
        postData,
        { headers: { Authorization: jwt } }
      );
      cambiarCargando({cargando : false});
      cambiarBandera({ bandera: true });
      agregartabla({});
      agregartabla(resultado.data.tablaBandeja);
      const estadoBandeja = {
        bandejaSeleccionada: bandejaSeleccionada,
        tabla: tabla
      };
      localStorage.setItem("estadoBandeja", estadoBandeja);
    }
    establecerRolCaptura(false);
    
     if(roles.includes(rolUsuario)){
        establecerRolCaptura(true);
     }
  };

  const handleAvisoUsuarioNovalidoClose = async () => {
    cambiarAvisoUsuarioNovalidoVisible({ avisoUsuarioNovalidoVisible : false });
    history.push('/menuJDE');
  };

  /* Uso de efectos */
  useEffect(() => {
    if (datosSesion === true) consultar();
  }, [bandejaSeleccionada]);

  /* Uso de efectos */
  useEffect(() => {
    const estado = menu.estados ? menu.estados[menu.idEstado] : undefined;
    const proceso = estado && estado.procesos ? estado.procesos[menu.idDetalle] : undefined;
    const distrito = proceso && proceso.distritos ? proceso.distritos[menu.idDistrito] : undefined;

    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

    if(idProcesoElectoral > 0 && idDetalleProceso > 0){
      if(bandejaSeleccionada === "6") {
        actualizaBandeja(KEY_BANDEJA_REGISTRADOS);
      }
      if (datosSesion === true) consultar();
    } else {
      history.push('/menuJDE');
    }
  }, [menu]);

  useEffect(() => {}, [bandera, cargando, avisoUsuarioNovalidoVisible]);

  /*Dibuja tabla*/
  return (
    <AuthenticatedComponent listo={funcionListo}>
      <Template
        contenido={
          <>
            <Menu />
            <div className="contenedor">
              <Row>
                  <Col sm={24} md={24} lg={24}>
                      <HeaderModule title={etiqueta_bandeja_titulo_modulo} redireccionar={'/menuJDE'} />
                  </Col>
              </Row>
              <div className="contenedor">
                <Row>
                  <Formulario buscarAspirante={buscarAspirante} />
                </Row>
                
              </div>
              <Row>
                  <br/>
                  <br/>
                <Text style={{color: '#1890ff'}}>
                          <Icon type="info-circle" theme="filled"
                              style={{fontSize: '1.0em'}} />
                                  {' '}  Las personas aspirantes de otro distrito son resaltadas en color <Text style={{color: 'var(--rosa-ine)'}}>rosa</Text>.
                        </Text><br/><br/>
                <Text style={{color: '#1890ff'}}>
                <img src={iconoDeclina} /> {' '}Indica que la o el aspirante decidió declinar su solicitud para participar como SE o CAE.
                </Text><br/><br/>
                <Text style={{color: '#1890ff'}}><b style={{color:'#C192F3'}}>(*)</b>{' '}Indica a la o el aspirante con credencial en trámite.</Text>
                </Row>
              <Row>
                  <Tabs activeKey={`${bandejaSeleccionada}`} onChange={actualizaTab} >
                      <TabPane tab={etiqueta_bandeja_registrados} key={KEY_BANDEJA_REGISTRADOS}>
                          <ComponentTablaBandeja actualizarCargando={cambiarCargando} datos={tabla.datos} tipoUsuario={tipoUsuario} banderaVisualizar={bandera.bandera} tituloTabla={etiqueta_resultado_registrados} rolCaptura={rolCaptura} keyTabPane="0" rolOPLE={roles_solo_consulta.includes(datosAspirante.user.currentUser.rolUsuario)}/>
                      </TabPane>
                      <TabPane tab={etiqueta_bandeja_por_validar} key={KEY_BANDEJA_POR_VALIDAR}>
                          <ComponentTablaBandeja actualizarCargando={cambiarCargando} datos={tabla.datos} tipoUsuario={tipoUsuario} banderaVisualizar={bandera.bandera} tituloTabla={etiqueta_resultado_validar}       rolCaptura={rolCaptura} keyTabPane="1" rolOPLE={roles_solo_consulta.includes(datosAspirante.user.currentUser.rolUsuario)}/>
                      </TabPane>
                      <TabPane tab={etiqueta_bandeja_con_observaciones} key={KEY_BANDEJA_CON_OBSERVACIONES} >
                          <ComponentTablaBandeja actualizarCargando={cambiarCargando} datos={tabla.datos} tipoUsuario={tipoUsuario} banderaVisualizar={bandera.bandera} tituloTabla={etiqueta_resultado_con_observaciones} rolCaptura={rolCaptura} keyTabPane="2" rolOPLE={roles_solo_consulta.includes(datosAspirante.user.currentUser.rolUsuario)}/>
                      </TabPane>
                      <TabPane tab={etiqueta_bandeja_acuden_JDE} key={KEY_BANDEJA_ACUDEN_JDE} >
                          <ComponentTablaBandeja actualizarCargando={cambiarCargando} datos={tabla.datos} tipoUsuario={tipoUsuario} banderaVisualizar={bandera.bandera} tituloTabla={etiqueta_resultado_acuden_JDE}    rolCaptura={rolCaptura} keyTabPane="3" rolOPLE={roles_solo_consulta.includes(datosAspirante.user.currentUser.rolUsuario)}/>
                      </TabPane>
                      <TabPane tab={etiqueta_bandeja_declinados} key={KEY_BANDEJA_DECLINADOS} >
                          <ComponentTablaBandeja actualizarCargando={cambiarCargando} datos={tabla.datos} tipoUsuario={tipoUsuario} banderaVisualizar={bandera.bandera} tituloTabla={etiqueta_resultado_declinados}    rolCaptura={rolCaptura} keyTabPane="4" rolOPLE={roles_solo_consulta.includes(datosAspirante.user.currentUser.rolUsuario)}/>
                      </TabPane>
                      <TabPane tab={etiqueta_bandeja_finalizados} key={KEY_BANDEJA_FINALIZADOS} >
                          <ComponentTablaBandeja actualizarCargando={cambiarCargando} datos={tabla.datos} tipoUsuario={tipoUsuario} banderaVisualizar={bandera.bandera} tituloTabla={etiqueta_resultado_finalizados}  rolCaptura={rolCaptura} keyTabPane="5" rolOPLE={roles_solo_consulta.includes(datosAspirante.user.currentUser.rolUsuario)}/>
                      </TabPane>
                  </Tabs>
              </Row>
              {
                <Row>
                  <ComponentTablaBandejaBusqueda
                    actualizarCargando={cambiarCargando}
                    datos={tabla.datosBusqueda}
                    tipoUsuario={tipoUsuario}
                    banderaVisualizar={bandera.bandera}
                    keyTabPane="6"
                    rol={datosAspirante.user.currentUser}
                    rolOPLE={roles_solo_consulta.includes(datosAspirante.user.currentUser.rolUsuario)}
                     />
                </Row>
              }
            </div>
          </>
        }
        bloqueado={false}
        guia={false}
        cargando={cargando.cargando}
      >
      </Template>
      <Modal
          title={null}
          footer={null}
          centered={true}
          visible={avisoUsuarioNovalidoVisible.avisoUsuarioNovalidoVisible}
          onOk={handleAvisoUsuarioNovalidoClose}
          onCancel={handleAvisoUsuarioNovalidoClose}>
        <div>
          <h3 style={{'textAlign': 'center'}}>PERMISOS INSUFICIENTES</h3>
          <h5 style={{'textAlign': 'center'}}>No tiene permiso para realizar esta acción.</h5>
        </div>
      </Modal>
    </AuthenticatedComponent>
  );
}

export default withRouter(Bandeja);